import React, {Context, ElementType, ReactElement} from 'react';

export interface ProviderProps {
    children: ReactElement | ReactElement[];
}

export function mergeStores(...Stores: ElementType[]) {
    return ({children}: { children: JSX.Element | JSX.Element[] }): JSX.Element => {
        let Root: JSX.Element = React.createElement(React.Fragment, null, children);
        for (const Store of Stores.reverse()) {
            Root = React.createElement(Store, null, Root);
        }
        return Root;
    };
}

export function createProvider<T>(context: Context<T | null>, value: T, props: ProviderProps) {
    return React.createElement(context.Provider, {value}, props.children);
}

export function createHook<T>(context: Context<T | null>, name: string, throwError = true) {
    return () => {
        const store = React.useContext(context);
        if (!store && throwError) {
            throw new Error(`You forgot to use the ${name} provider!`);
        }
        return store as T;
    };
}

export const store = {
    mergeStores,
    createProvider,
    createHook,
};